<template>
  <div class="liquor-brand">
    <div class="header">
      代表品牌
      <img src="/liquor/代表品牌.png" />
    </div>

    <div class="brands">
      <img
        class="logo"
        :src="util.getImageUrl(item.logo)"
        v-for="(item, index) in list"
        :key="index"
        @click="goto(item)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Brand",
  data() {
    return {
      list: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;
      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorBrand",
        methodName: "retrieve",
        params: {
          pageNum: 1,
          focus: true
        }
      });

      this.list = response.results;
    },
    goto(item) {
      // this.$router.push({
      //   path: "/liquor/browser",
      //   query: {
      //     6: item.brand
      //   }
      // });
    }
  }
};
</script>

<style lang="scss">
.liquor-brand {
  width: 1100px;
  margin: 0 auto;
  margin-top: 100px;

  .header {
    width: 323px;
    margin: 0 auto;
    height: 36px;
    font-size: 32px;
    font-family: "FZQKBYSJW";
    font-weight: normal;
    color: rgba(59, 41, 9, 1);
    line-height: 36px;
    text-align: center;

    position: relative;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 323px;
      height: 36px;
    }
  }

  .brands {
    width: 100%;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    .logo {
      display: inline-block;
      width: 100px;
      margin: 20px;
      // cursor: pointer;
      //   min-height: 150px;
    }
  }
}
</style>